const config = {
  accept: "application/json",
  content_type: "application/json",
  authorization: "Bearer ",
  headers: {
    Accept: "application/json"
  },
  timeout: 10000
};

export default config;
